// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"pY-z","sponsoredTooltipWrapper":"qY-z","sponsoredTooltip":"rY-z","newCard":"sY-z"};